import { HOME_PAGE } from "../types";


export interface IHomePage {
  path: string
}

const initialState: IHomePage = {
  path:"/"
};

export const homePageReducer = (state: IHomePage = initialState, action: any): IHomePage => {
  switch (action.type) {
    case HOME_PAGE.HOME_PAGE_SET_SELECTED:
   
      return {
        ...state,
        path: action.payload.path,
      }
    case HOME_PAGE.HOME_PAGE_CLEAR_SELECTED:
      return {
        ...state,
        path: initialState.path,
      }
    default:
      return state;
    }
};
